import React from 'react'
import { Helmet } from 'react-helmet';
import Header4 from '../../components/header/header4/Header4';
import Footer from '../../components/footer/Footer'
import ServiceListSection from '../../components/service_list_section/ServiceListSection'
import ShortWhyWeareBest from '../../components/short_why_we_are_best/ShortWhyWeareBest'

export default function Services() {
  return (
    <>
    <Helmet>
  <title>Services | SARS India Liaison Pvt. Ltd. – Statutory Industrial Consulting, Licensing & Environmental Approvals</title>

  <meta
    name="description"
    content="Explore our comprehensive statutory consulting services including PESO licensing, environmental and forest clearances, fire safety NOCs, biomedical waste authorization, CGWA approvals, and more across India."
  />

  <meta
    name="keywords"
    content="SARS India Liaison, statutory consulting services, PESO approvals, environmental clearance, forest clearance, biomedical waste authorization, fire licensing, CGWA NOC, AAI clearance, compliance consulting, India entry strategy, regulatory services"
  />

  <meta name="author" content="Sars India Liaison Pvt. Ltd." />

  <link rel="canonical" href="https://www.sarsindialiaison.com/services" />
</Helmet>

    
   <Header4/>
    <ServiceListSection/>
    <ShortWhyWeareBest/>
    <Footer/>
    </>
  






  )
}
